export class StringHelper {
	public capitalizeFirstLetter(str: string): string {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
	public pad(str: string, width: number, char: string): string {
		return str.length >= width ? str : new Array(width - str.length + 1).join(char) + str;
	}
	public isNullOrEmpty(str: string): boolean {
		return str === null || str === '';
	}
	public seoFriendlyUrl(str: string): string {
		return str
			.toString()
			.toLowerCase()
			.replace(/[��]/g, 'a') // Replace spaces with -
			.replace(/[�]/g, 'o') // Replace spaces with -
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(/[^\w-]+/g, '') // Remove all non-word chars
			.replace(/--+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, ''); // Trim - from end of text
	}

	public urlify(str: string, target: string = '_blank') {
		const urlRegex = /(https?:\/\/[^\s]+)/g;
		return str.replace(urlRegex, `<a target="${target}" href="$1">$1</a>`);
	}
}

String.prototype['capitalizeFirstLetter'] = function (this: string) {
	return new StringHelper().capitalizeFirstLetter(this);
};
String.prototype['pad'] = function (this: string, width: number = 2, char: string) {
	return new StringHelper().pad(this, width, char);
};
String.isNullOrEmpty = (str: string) => new StringHelper().isNullOrEmpty(str);
